var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeOnContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 210,
    r: 210,
    fill: "#FBFFFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.561 84.778H91.658C90.065 84.778 89.0135 85.9727 88.7735 87.6624C88.5336 89.3522 88.002 93.462 88 105.41C87.998 117.358 88.6327 123.166 88.6327 123.166C88.8727 124.951 90.0404 126.019 91.6175 126.042L112.609 126.336C113.806 126.353 114.829 125.357 115.415 124.313C116.329 122.684 117.179 120.676 122.596 120.652C130.406 120.618 130.835 124.625 130.835 126.846C130.835 129.067 130.589 322.968 130.589 322.968C130.976 330.517 160.541 339.449 176.775 340.978C179.687 341.253 182.002 338.867 181.996 335.942L181.987 331.506C181.983 329.512 183.598 327.893 185.593 327.893H262.921C325.47 327.893 331.509 264.05 331.509 264.05C336.901 216.816 295.49 196.541 295.49 196.541C295.49 196.541 311.882 181.875 311.882 157.503C311.882 129.14 287.369 118.619 287.369 118.619C257.384 105.728 234.36 118.088 230.107 124.507C228.906 126.32 230.446 129.173 232.618 129.267C248.957 129.267 263.682 132.559 262.984 157.503C262.286 182.446 236.137 182.037 232.618 182.037H185.282C183.294 182.037 181.681 180.427 181.677 178.438L181.573 127.054C181.573 97.3126 220.541 97.8216 238.569 98.0571C238.916 98.0616 239.255 98.066 239.586 98.0701C266.165 98.4003 284.813 106.116 292.098 109.718C293.615 110.468 295.085 109.381 294.163 107.962C287.85 98.2365 260.039 79.6761 230.527 79.6761C178.249 78.4326 146.288 79.2218 136.333 79.5526C134.563 79.6114 133.262 81.2655 133.175 83.0345C132.988 86.8223 131.089 94.493 122.596 94.493C117.663 94.493 115.851 89.3218 115.163 86.7343C114.719 84.7667 113.261 84.778 112.561 84.778ZM185.385 225.227C183.39 225.227 181.775 226.846 181.779 228.84L181.88 278.57C181.884 280.558 183.497 282.168 185.485 282.168H242C242 282.168 281.254 283.138 281.147 252.943C281.039 222.747 244.049 225.227 244.049 225.227H185.385Z",
    fill: "#3185FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6_3",
    x: 87,
    y: 78,
    width: 245.993,
    height: 264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeOnContrast);
export default __webpack_public_path__ + "static/media/badge-on-contrast.2fc7f5bfd4e4cabf51949aac6443e145.svg";
export { ForwardRef as ReactComponent };